import React from "react"
import styled from "styled-components"
import { graphql } from "gatsby"
import { down, up } from "styled-breakpoints"

//STYLES
import { H4, Text, Label } from "../utils/typo"
import { Section2 } from "../utils/utils"
//COMPONENTS
import SEO from "../components/seo/SEO"
import Layout from "../layout/layout2"

const Info = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  //grid-column-gap: 7rem;

  ${down("sm")} {
    grid-template-columns: 1fr;
    grid-row-gap: 1rem;
  }

  p {
    white-space: pre-wrap;
  }

  iframe {
    min-height: 500px;
    //filter: grayscale(100%);
    ${down("sm")} {
      display: none;
    }
  }
`

const TextWrapper = styled.div`
  padding-top: 4rem;
  padding-bottom: 6rem;
  padding-left: 5rem;
  width: 100%;
  margin-right: auto;
  margin-left: 0;
  max-width: 800px;

  ${down("lg")} {
    max-width: 600px;
  }

  ${down("md")} {
    max-width: 480px;
  }

  ${down("sm")} {
    margin-top: 4rem;
    max-width: 360px;
    padding-right: 1rem;
    padding-left: 1rem;
  }

  ${down("xs")} {
    max-width: 540px;
    margin-right: auto;
    margin-left: auto;
    padding-right: 1rem;
    padding-left: 1rem;
  }

  b {
    margin-right: 1rem;
  }
`

const MapMobile = styled.div`
  //margin-top: 4rem;
  margin-bottom: -4rem;
  > div {
    height: 400px;
  }

  iframe {
    filter: grayscale(100%);
    height: 400px;
  }

  ${up("md")} {
    display: none;
  }
`

const Kontakt = ({ pageContext, data }) => {
  const page = data.datoCmsKontaktPage
  const pl = pageContext.locale === "pl-PL"

  return (
    <div>
      <SEO title="Kontakt" slug="/kontakt" />
      <Layout lang={pageContext.locale} slug={pageContext.slug}>
        <Section2
          pt={0}
          pb={0}
          tabIndex="0"
          role="contentinfo"
          ariaLabel="Dane kontaktowe i mapa dojazdu"
        >
          <Info>
            <iframe
              title="map"
              width="100%"
              height="100%"
              frameBorder="0"
              scrolling="no"
              marginHeight="0"
              marginWidth="0"
              src="https://www.openstreetmap.org/export/embed.html?bbox=18.897334635257724%2C50.30437967067119%2C18.901813924312595%2C50.30593861257248&amp;layer=mapnik&amp;marker=50.30515914800942%2C18.899574279785156"
            />

            <TextWrapper>
              <Label>{pl ? "Kontakt" : "Contact"}</Label>
              <H4 mt="2rem">
                {pl ? "tel. " : "phone "}+48 {page.telefon}
              </H4>
              <H4>fax +48 {page.fax}</H4>
              <H4 mb="3rem">{page.mail}</H4>

              <Label mb="2rem">{pl ? "Adres" : "Address"}</Label>
              <Text mt="2rem">
                <b>{page.name}</b>
              </Text>
              <Text>
                {pl ? "ul. " : ""}
                {page.ulica} {page.nrBudnku}
              </Text>
              <Text>
                {page.kodPocztowy} {page.miasto}
              </Text>
              <Text>
                {pl ? "Województwo " : ""}
                {page.wojew}
              </Text>
              <Text>{page.kraj}</Text>

              <Text mt="2rem">
                <b>{pl ? "NIP: " : "tax ID: "}</b>
                {page.nip}
              </Text>
              <Text>
                <b>{pl ? "REGON: " : "REGON: "}</b>
                {page.regon}
              </Text>
              <Text>
                <b>{pl ? "KRS: " : "KRS: "}</b>
                {page.krs}
              </Text>
              <Text mt="2rem">
                <b>{pl ? "Zarejestrowana w: " : "Registered in: "}</b>
                <br />
                {page.sad}
              </Text>
              <Text>
                <b>{pl ? "Kapitał zakładowy: " : "Share capital: "}</b>
                {page.kapital}
              </Text>
              <Text mt="2rem">
                <b>{pl ? "Nr konta (PLN): " : "Bank account number (PLN): "}</b>
                <br />
                {page.konto}
              </Text>
            </TextWrapper>
          </Info>

          <MapMobile>
            <iframe
              title="mapMobile"
              width="100%"
              height="100%"
              frameBorder="0"
              scrolling="no"
              marginHeight="0"
              marginWidth="0"
              src="https://www.openstreetmap.org/export/embed.html?bbox=18.897334635257724%2C50.30437967067119%2C18.901813924312595%2C50.30593861257248&amp;layer=mapnik&amp;marker=50.30515914800942%2C18.899574279785156"
            />
          </MapMobile>
        </Section2>

        <Section2
          pt={3}
          pb={3}
          tabIndex="0"
          role="contentinfo"
          ariaLabel="Dane kontaktowe i mapa dojazdu"
        >
          <Info>
            <iframe
              title="map"
              width="100%"
              height="100%"
              frameBorder="0"
              scrolling="no"
              marginHeight="0"
              marginWidth="0"
              src="https://www.openstreetmap.org/export/embed.html?bbox=18.526629209518436%2C50.12938935172033%2C18.54454636573792%2C50.1356477269215&amp;layer=mapnik&amp;marker=50.13251864163558%2C18.535587787628174"
            />
            <TextWrapper>
              <Label mb="2rem">{pl ? "Adres placówki" : "Address"}</Label>
              <Text mt="2rem">
                <b>{page.nazwaPlacowki}</b>
              </Text>
              <p>
                {pl ? "ul. " : ""}
                {page.ulicaPlacowki} {page.nrBudPlacowki}
              </p>
              <p>
                {page.kodPlacowki} {page.miastoPlacowki}
              </p>
              <p>
                {pl ? "Województwo " : ""}
                {page.wojewPlacowki}
              </p>
              <p>{page.kraj}</p>
            </TextWrapper>

            {/* <iframe
              title="map"
              width="100%"
              height="100%"
              frameBorder="0"
              scrolling="no"
              marginHeight="0"
              marginWidth="0"
              src="https://www.openstreetmap.org/export/embed.html?bbox=18.524708747863773%2C50.12771114272596%2C18.538870811462406%2C50.133969737398864&amp;layer=mapnik&amp;marker=50.13084054237816%2C18.531789779663086" 
            /> */}
          </Info>

          <MapMobile>
            <iframe
              title="mapMobile"
              width="100%"
              height="100%"
              frameBorder="0"
              scrolling="no"
              marginHeight="0"
              marginWidth="0"
              src="https://www.openstreetmap.org/export/embed.html?bbox=18.526629209518436%2C50.12938935172033%2C18.54454636573792%2C50.1356477269215&amp;layer=mapnik&amp;marker=50.13251864163558%2C18.535587787628174"
            />
          </MapMobile>
        </Section2>
      </Layout>
    </div>
  )
}
export default Kontakt

export const query = graphql`
  query KontaktQuery($locale: String!) {
    datoCmsKontaktPage(locale: { eq: $locale }) {
      name
      ulica
      nrBudnku
      kodPocztowy
      miasto
      wojew
      kraj
      telefon
      mail
      locale
      slug
      fax
      nip
      krs
      regon
      kapital
      sad
      konto

      nazwaPlacowki
      ulicaPlacowki
      nrBudPlacowki
      kodPlacowki
      miastoPlacowki
      wojewPlacowki
    }
  }
`
